module.exports = __webpack_public_path__ + "img/cad_cadastro.fa36aa48.png";